/** Штраф к шкале бомбы за открытую ИИ обманку. */
export const DECOY_HEAT = 0.25;
/** Если ИИ-судья уверен в этом (или сильнее), что подсказка — родня слову с поля, ход не засчитывается. */
export const ROOT_JUDGE_THRESHOLD = 0.8;
/** Звёздные пороги по итоговому нагреву бомбы. */
export const STAR_THRESHOLDS = { three: 0.25, two: 0.5 } as const;

export const BOARD_SIZE = 12;
export const TARGET_COUNT = 4;
export const DECOY_COUNT = 7;
export const MAX_CLUE_LENGTH = 30;
